import { inject } from '@angular/core';
import { catchError, from, map, Observable, of } from 'rxjs';
import { AuthProviderId, AuthService } from '@auth/infra';

export class IsPasswordAccountQueryHandler {
  private readonly authService: AuthService = inject(AuthService);

  isPasswordAccount(): Observable<boolean> {
    return from(this.authService.getCurrentProviderId()).pipe(
      map((provider: AuthProviderId) => provider === AuthProviderId.Password),
      catchError(() => of(false))
    );
  }
}
